import React from "react";
import { GenderValue } from "shared";
import { styled, Theme } from "@mui/material";
import { PatientColorMap } from "../../layout/patientColorMap";
import { CHAT_ELEMENT_HEIGHT } from "../consts/sizeConsts";
import { useTranslate } from "../../hooks/useTranslate";
import { useNavigation } from "../../state/navigationContext";
import {
  onRtl,
  paddingRightToPaddingLeftOnRtl,
} from "fe-web-components/rtl/rtlStyles";
import { ReactComponent as GenericFemaleIcon } from "fe-web-components/assets/femaleIconGeneric.svg";
import { ReactComponent as GenericMaleIcon } from "fe-web-components/assets/maleIconGeneric.svg";
import clsx from "clsx";
import { PatientThemeImage } from "../../themes/PatientThemeImage";

const MaleFemaleContainerView = styled("div")(
  ({ theme, disabled }: { theme?: Theme; disabled: boolean }) => ({
    textAlign: "center",
    display: "flex",
    paddingLeft: "6px",
    paddingRight: "0px",
    //fontFamily: FONT_FAMILY_LATIN,
    ...onRtl({
      // fontFamily: FONT_FAMILY_HEB,
      paddingLeft: "0px",
      paddingRight: "6px",
    }),
    alignItems: "center",
    height: CHAT_ELEMENT_HEIGHT,
    color: PatientColorMap.Default,
    backgroundColor: PatientColorMap.Unselected,
    "&.selected": { color: "white", backgroundColor: PatientColorMap.Selected },
    borderRadius: "30px",
    "&:hover": {
      cursor: disabled === true ? "default" : "pointer",
    },
  }),
);

const MaleFemaleIcon = styled("div")({
  display: "flex",
  justifyContent: "center",
  ...paddingRightToPaddingLeftOnRtl(6),
  "& img": {
    borderRadius: "50%",
  },
  "& circle": {
    fill: "var(--selected)",
  },
});

export interface MaleFemaleContainerIF {
  selected: boolean;
  disabled: boolean;
  onClick: (gender: GenderValue) => void;
  gender: GenderValue;
  className?: string;
}

const GenderText = styled("div")(
  ({ theme, selected }: { theme?: Theme; selected: boolean }) => ({
    fontWeight: 500,
    marginRight: "15px",
    marginLeft: "4px",
    ...onRtl({
      marginRight: "4px",
      marginLeft: "15px",
    }),
    fontSize: "15px",
    color: selected === true ? "white" : PatientColorMap.Default,
  }),
);

export const MaleFemaleContainer = ({
  selected,
  disabled,
  onClick,
  gender,
  ...props
}: MaleFemaleContainerIF) => {
  const { translate } = useTranslate();
  const { themeSettings } = useNavigation();

  return (
    <MaleFemaleContainerView
      className={clsx(
        props.className,
        "male-female-container-view",
        selected ? "selected" : "",
      )}
      disabled={disabled}
      onClick={() => onClick(gender)}
    >
      <MaleFemaleIcon>
        {gender === GenderValue.MALE &&
          (!themeSettings?.maleIcon ? (
            <GenericMaleIcon />
          ) : (
            <PatientThemeImage source={themeSettings.maleIcon} />
          ))}
        {gender === GenderValue.FEMALE &&
          (!themeSettings?.femaleIcon ? (
            <GenericFemaleIcon />
          ) : (
            <PatientThemeImage source={themeSettings.femaleIcon} />
          ))}
      </MaleFemaleIcon>
      <GenderText selected={selected}>
        {gender === GenderValue.MALE ? translate("MALE") : translate("FEMALE")}
      </GenderText>
    </MaleFemaleContainerView>
  );
};
